// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1kRvN","footer":"ModalUpdate_footer__17X7s"};